import { CosmosText, CosmosTextProps } from "@cosmos/web-react";
import classNames from "classnames/bind";
import styles from "./KickerNew.module.css";

const cx = classNames.bind(styles);

export const KickerNew = ({
  children,
  className,
  tag = "p",
  appearance = "dark",
  size = "small",
}: {
  children: React.ReactNode;
  className?: string;
  tag?: CosmosTextProps["tag"]; // 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span';
  appearance?: CosmosTextProps["appearance"]; // 'dark' | 'light';
  // TODO: don't manually define these variants, but `CosmosTextSize` is just string typed
  size?: "xx-small" | "x-small" | "small" | "medium" | "large" | "x-large";
}) => (
  <CosmosText
    className={cx("kicker", className)}
    kind="subtle"
    size={size}
    weight="bold"
    appearance={appearance}
    tag={tag}
  >
    {children}
  </CosmosText>
);
